@if (wholeSaleElement) {
  <app-tabs>
    <app-tab [title]="'settlement.view.details'">
      <app-value-details
        [collection]="wholesaleMasterdata"
        [data]="wholeSaleElement"
      ></app-value-details>
    </app-tab>
    <app-tab [title]="'settlement.view.data'">
      <app-table
        [config]="tableConfig"
        [data]="tableData">
      </app-table>
    </app-tab>
    <app-tab [title]="'settlement.view.request'">
      {{ wholeSaleElement.rsmTextRequest ?? '-' }}
    </app-tab>
    <app-tab [title]="'settlement.view.answer'">
      {{ wholeSaleElement.rsmTextResponse ?? '-' }}
    </app-tab>
  </app-tabs>
}

